import { useState, forwardRef, useImperativeHandle, useContext, useEffect } from 'react';
import { Row, Col, Input, message } from 'antd';
import PSAIModal from '@PSAIComponents/PSAIModal';
import styles from './index.module.scss';
import { AppContext } from '@utils/AppContext';
import API from '@api/api.js';
import eventBus from '@utils/eventBus';

const InvitationLink = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        setInvitationLinkVisible
    }));
    const { globalOrgInfo } = useContext(AppContext);
    const [invitationLinkVisible, setInvitationLinkVisible] = useState(false)
    const [lackVisible, setLackVisible] = useState(false)
    const [link, setLink] = useState()


    const generateInvitingLink = () => {
        if (!localStorage.getItem('token')) return
        API.generateInvitingLink().then((res) => {
            if (res.code == 0) {
                setLink(window.location.origin + '/?' + res.data)
            } else if (res.code == -5063) {
                setLackVisible(true)
            } else {
                message.error(res.message)
            }
        })
    }

    useEffect(() => {
        if (!invitationLinkVisible) return
        generateInvitingLink()
    }, [invitationLinkVisible])

    const copyLink = () => {
        if (!link) return;

        const fullLink = link;

        // 如果 clipboard API 可用
        if (navigator.clipboard && window.isSecureContext) {
            navigator.clipboard.writeText(fullLink)
                .then(() => {
                    message.success('复制成功');
                })
                .catch(err => {
                    console.error('Clipboard error:', err);
                    message.error('复制失败，请手动复制');
                });
        } else {
            // 兼容旧浏览器
            const textarea = document.createElement('textarea');
            textarea.value = fullLink;
            textarea.style.position = 'fixed';
            textarea.style.top = '-9999px';
            document.body.appendChild(textarea);
            textarea.focus();
            textarea.select();

            try {
                const success = document.execCommand('copy');
                if (success) {
                    message.success('复制成功');
                } else {
                    message.warning('复制失败，请手动复制');
                }
            } catch (err) {
                console.error('Fallback copy error:', err);
                message.error('复制失败，请手动复制');
            }

            document.body.removeChild(textarea);
        }
        setInvitationLinkVisible(false)
    };


    return (
        <>
            <PSAIModal
                title='邀请成员'
                maxWidth={400}
                okText={'复制链接'}
                open={invitationLinkVisible}
                maskClosable={false}
                okButtonProps={{ disabled: false, loading: false, style: { width: '100%', margin: '0' } }}
                onCancel={() => setInvitationLinkVisible(false)}
                onOk={() => copyLink()}
                cancelButtonProps={{ style: { display: 'none' } }}
            >
                <div className={styles.editNameContent}>
                    <Input
                        className={styles.input}
                        value={link} />
                    <p>• 复制链接邀请成员，成员访问链接即可申请加入</p>
                    <p>• 企业成员将共享虹豆额度</p>
                </div>
            </PSAIModal>
            <PSAIModal
                title='席位不足'
                maxWidth={400}
                okText={'企业管理'}
                open={lackVisible}
                maskClosable={false}
                okButtonProps={{ disabled: false, loading: false, style: { width: '100%', margin: '0' } }}
                onOk={() => { setLackVisible(false); setInvitationLinkVisible(false) }}
                onCancel={() => { setLackVisible(false); setInvitationLinkVisible(false) }}
                cancelButtonProps={{ style: { display: 'none' } }}
            >
                <div className={styles.lackContent}>
                    <p>您的企业<span>【{globalOrgInfo?.current?.orgName}】</span>席位不足</p>
                    <p>请前往企业管理处理</p>
                </div>
            </PSAIModal>
        </>


    );
});

export default InvitationLink;